module.exports = __webpack_public_path__ + "img/tower-broadcast.60104ea9.svg";